import './StockStatusFilter.css';

interface StockStatusFilterProps {
  inStockOnly: boolean;
  onStockFilterChange: (inStock: boolean) => void;
}

const StockStatusFilter: React.FC<StockStatusFilterProps> = ({
  inStockOnly,
  onStockFilterChange,
}) => {
  return (
    <div className="stock-status-filter">
      <label className="stock-status-filter__label">
        <input
          type="checkbox"
          className="stock-status-filter__checkbox"
          checked={inStockOnly}
          onChange={(e) => onStockFilterChange(e.target.checked)}
        />
        <span className="stock-status-filter__text">僅顯示有庫存商品</span>
      </label>
    </div>
  );
};

export default StockStatusFilter;
